export default {"src":"/_next/static/media/extras.89ee7e9e.svg","height":33,"width":28,"blurWidth":0,"blurHeight":0};